/**
 * Logger centralisé — Pharma Gestion
 * En production : seules les erreurs sont affichées
 * En développement : tous les niveaux sont affichés
 */

const IS_DEV = process.env.NODE_ENV === "development";

const logger = {
  /** Log de debug — visible seulement en dev */
  debug: (msg, ...args) => {
    if (IS_DEV) console.log(`[DEBUG] ${msg}`, ...args);
  },

  /** Log d'info — visible seulement en dev */
  info: (msg, ...args) => {
    if (IS_DEV) console.info(`[INFO] ${msg}`, ...args);
  },

  /** Avertissement — visible seulement en dev */
  warn: (msg, ...args) => {
    if (IS_DEV) console.warn(`[WARN] ${msg}`, ...args);
  },

  /** Erreur — toujours visible (prod + dev) */
  error: (msg, ...args) => {
    console.error(`[ERROR] ${msg}`, ...args);
  },

  /** Log de scan/vente — jamais en prod (données sensibles) */
  scan: (msg, ...args) => {
    if (IS_DEV) console.log(`[SCAN] ${msg}`, ...args);
  },
};

export default logger;
